import styled from 'styled-components';

export const H1 = styled.h1`
    font-size: 2rem;
`;
